import React from 'react';
import { Button } from '@planne-software/uni/Button';
import { useStore } from 'react-redux';
import { useAppSelector, useTranslate } from '@src/core/hooks';
import type { RootState } from '@src/core/store';
import { additionalsSelectionIsCompleteSelector, selectedAdditionalsSelector } from '@src/stores/product';
import { IconCheck } from '@tabler/icons-react';
import { track } from '@src/services/analytics';
import { trackStepConfirmed } from '@src/domains/products/features/product-adder-v2/analytics/widgetTracking';
import { FooterActions } from './styles';

export type AdditionalsFooterProps = {
  widgetId: string;
  productId: string;
  onConfirmed: () => void;
};

export const AdditionalsFooter = (props: AdditionalsFooterProps) => {
  const { widgetId, productId, onConfirmed } = props;
  const { i18n } = useTranslate();
  const store = useStore<RootState>();

  const canConfirm = useAppSelector(additionalsSelectionIsCompleteSelector(widgetId, productId));

  const onConfirm = () => {
    const additionalsCount = selectedAdditionalsSelector(widgetId, productId)(store.getState()).length;
    track('productAdderAdditionalsConfirmed', {
      productId,
      additionalsCount,
    });
    trackStepConfirmed(widgetId, productId, 'additionals');
    onConfirmed();
  };

  return (
    <FooterActions>
      <Button
        variant='contained'
        fullWidth
        disabled={!canConfirm}
        startSlot={<IconCheck size={20} />}
        onClick={onConfirm}
      >
        {i18n('base_confirm')}
      </Button>
    </FooterActions>
  );
};
